import Text from '@shared/components/Text/Text'
import { type FunctionComponent } from 'react'
import Inline from '../Inline/Inline'
import * as styles from './List.css'

const ListItem: FunctionComponent<any> = function ({ ...child }) {
  return (
    <Text
      className={styles.listItem}
      // @ts-expect-error custom var not typed
      style={{ '--num': child.ebene }}
    >
      {child?.children?.[0]?.type === 'symbol' && (
        <span
          className={styles.listItemEnumeration}
          // @ts-expect-error custom var not typed
          style={{ '--chars': child.children?.[0]?.stellen }}
        >
          <Inline {...child.children?.[0]} />
        </span>
      )}
      <Inline {...child} skipInitialSymbol />
    </Text>
  )
}

export default ListItem
